import { IconButton, Typography, Tooltip } from "@mui/material";
import moment from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useAppContext } from "src/hooks";
import MessageMenu from "./MessageMenu";
import { useCallback, useEffect, useRef, useState } from "react";
import { s3baseUrl } from "src/config";
import { AudioPlayer, Iconify, UserAvatar } from "src/components";
import { capitalize } from "lodash";
import TempReply from "./TempReply";
import ReplyIcon from "@mui/icons-material/Reply";
import { memo } from "react";
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import EmojiPicker from "emoji-picker-react";
import ChatMessageReaction from "./chatMessageReaction";
import { add_message_reaction, remove_message_reaction, _getMessageDetail } from "src/DAL/chat";
import { useSnackbar } from "notistack";

function MessageItem({
  hoveredMessageId,
  isReplyIconVisible,
  repliedMessage,
  setRepliedMessage,
  setReplyMessage,
  loadMoreMessages,
  isDateSame,
  message,
  setIsEditingMessage,
  setNewMessageText,
  setTargetEditMessage,
  nextMessage,
  textareaRef,
  selectedMessage,
  setSelectedMessage,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const emojiPickerRef = useRef(null);
  const { socketEmit, dispatch_get_user_profile, messageList, setMessageList, currentChat } = useAppContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const user = dispatch_get_user_profile();
  const messageListRef = useRef([]);

  const handleRemoveEmoji = useCallback(async function (removedItem) {
    const emojiData = {
      message_id: message._id,
      reaction: {
        unified: removedItem.unified,
        emoji: removedItem.emoji,
      },
      user_id: user.user_id,
    };
    let findedEmoji = message.message_reactions.find((item) => {
      return item._id === removedItem._id;
    });
    let isDeleteEmoji = findedEmoji?.reacting_user_ids.includes(user.user_id);

    console.log(findedEmoji, isDeleteEmoji);
    if (isDeleteEmoji) {
      console.log("Calling the Remove reaction socket event", removedItem, findedEmoji, emojiData);
      socketEmit("remove_reaction_event", emojiData);

      // setMessageList(prev => {
      //   return prev.filter((msg, index) => {
      //     return !(
      //       msg?.message_type !== "general" &&
      //       (msg?.reply_message_detail?._id === message?._id || msg?.reply_message_id === message?._id) &&
      //       msg?.message_reactions?.[0]?.unified === removedItem?.unified
      //     );
      //   })
      // })
    }
  }, [message]);

  async function emojiClickHandle(e) {
    let findedEmoji = message?.message_reactions?.find((item) => {
      return item.unified === e.unified;
    });
    let isDeleteEmoji = findedEmoji?.reacting_user_ids.includes(user.user_id);
    console.log("Is Emoji Adding?", isDeleteEmoji);
    
    if (!isDeleteEmoji) {
      const emojiData = {
        message_id: message._id,
        reaction: {
          unified: e.unified,
          emoji: e.emoji,
        },
      };
      console.log("Emoji Data before Adding to API:", emojiData);
      const result = await add_message_reaction(emojiData);
      if (result.code === 200) {
        socketEmit("add_reaction_event", {
          message_id: message._id,
          alert_id: result.data.alert_message,
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } else {
      handleRemoveEmoji(findedEmoji);
    }
    setSelectedMessage(null);
  }

  function linkifyText(text) {
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      const href = url.startsWith("http") ? url : `https://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }

  const handleReplyClick = async () => {
    let replyMessageDetailId = message?.reply_message_detail ? message?.reply_message_detail?._id : message?.reply_message_id
    console.log(message, replyMessageDetailId, "id");
    let result = await _getMessageDetail(replyMessageDetailId);
    if (result.code !== 200) {
      enqueueSnackbar("Message not Found", { variant: "error" });
      return;
    }

    while (true) {
      let updatedList = messageListRef.current;
      let foundMessage = updatedList.find((item) => item._id === (replyMessageDetailId));

      if (foundMessage) {
        document.getElementById(replyMessageDetailId)?.scrollIntoView({ behavior: "smooth" });
        console.log("Message found and scrolled to it.");
        setRepliedMessage(foundMessage);
        return;
      }

      if (updatedList.length > 0) {
        const container = document.querySelector(".scroll-div");
        const lastElement = document.getElementById(updatedList[updatedList.length - 1]?._id);
        if (lastElement && container) {
          console.log("Scrolling to the Message:");
          const offset = lastElement.offsetTop - 70;
          container.scrollTo({ top: offset, behavior: "smooth" });
        }
      }

      await new Promise((resolve) => setTimeout(resolve, 1500));
    }
  };

  useEffect(() => {
    messageListRef.current = messageList;
    // console.log(messageList, "changed, message list");

  }, [messageList]);

  useEffect(() => {
    if (repliedMessage) {
      setTimeout(() => {
        setRepliedMessage();
      }, 3000);
    }
  }, [repliedMessage]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setSelectedMessage(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!selectedMessage || selectedMessage._id !== message._id) return;
    const container = emojiPickerRef.current || document;
    const selectedCodes = new Set(
      message?.message_reactions?.filter(r => r.reacting_user_ids.includes(user.user_id)).map(r => r.unified)
    );
    selectedCodes.forEach((code) => {
      const btn = container.querySelector(`button[data-unified="${code}"]`);
      if (btn) btn.classList.add("highlighted-emoji");
    });

    return () => {
      selectedCodes.forEach((code) => {
        const btn = container.querySelector(`button[data-unified="${code}"]`);
        if (btn) btn.classList.remove("highlighted-emoji");
      });
    };
  }, [selectedMessage]);
  let isShowProfile = message.sender_id !== nextMessage?.sender_id || !isDateSame || nextMessage.message_type !== "general";
  if (message.message_type !== "general") {
    return (
      <div className="alert-message-container">
        <div className="alert-message" onClick={handleReplyClick}>
          <div
            dangerouslySetInnerHTML={{
              __html: message.text,
            }}
          />
        </div>
      </div>
    )
  }
  else if (message.sender_id == user.user_id) {
    return (
      <div>
        {(isShowProfile) && (
          <div className="sender-message-position">
            <div className="sender-message-info">
              <Typography className="sender-text">You</Typography>
              <div className="sender-avatar">
                <UserAvatar
                  image={message.message_sender.image}
                  name={
                    message?.message_sender?.first_name +
                    " " +
                    message?.message_sender?.last_name
                  }
                  sx={{ width: "28px", height: "28px", mr: 1 }}
                  alt="sender"
                />
              </div>
            </div>
          </div>
        )}
        <div className={`d-flex align-items-center justify-content-end message-margin`}>
          <div
            className={`mr-1 sent-message message-item reply-effect-container ${repliedMessage?._id === message._id ? "reply-effect" : ""}`}
            style={{
              marginTop:
                isShowProfile
                  ? "1rem"
                  : "0.1rem",
            }}
          >
            {isReplyIconVisible && hoveredMessageId === message._id && (
              <div className="send-reply-btn">
                <Tooltip
                  arrow
                  title="You can also reply to Message by Double clicking on it."
                >
                  <IconButton
                    className="textarea-btn mx-2"
                    color="secondary"
                    onClick={() => {
                      setReplyMessage(message);
                      textareaRef.current.focus();
                      console.log(message);
                    }}
                  >
                    <ReplyIcon className="voice-icon-messages" />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            {message.message_reactions && message.message_reactions.length > 0 &&
              <ChatMessageReaction emojiList={message.message_reactions} handleRemoveEmoji={handleRemoveEmoji} />
            }
            {message?.reply_message_detail && (
              <TempReply
                message={message}
                setRepliedMessage={setRepliedMessage}
                handleReplyClick={handleReplyClick}
              />
            )}
            {message.image && !message.audio_duration && (
              <>
                <a href={s3baseUrl + message.image} target="_blank">
                  <img
                    src={s3baseUrl + message.image}
                    alt={"image"}
                    className="chat-item-img"
                  />
                </a>
                <Typography fontSize={12} className="clickable-link" dangerouslySetInnerHTML={{ __html: linkifyText(message.text) }} />
              </>
            )}
            {message.image && message.audio_duration && (
              <div className="pt-2">
                <AudioPlayer
                  duration={message.audio_duration}
                  audioUrl={s3baseUrl + message.image}
                />
              </div>
            )}
            {!message.image && (
              <Typography className="clickable-link" dangerouslySetInnerHTML={{ __html: linkifyText(message.text) }} />
            )}
            <div>
              <Typography className="chat-date">
                {moment(message.createdAt).format("hh:mm A")}
              </Typography>
            </div>
          </div>
          <div className="message-options">
            {message._id && (
              <IconButton
                style={{ visibility: isReplyIconVisible && hoveredMessageId === message._id ? "visible" : "hidden" }}
                size="small"
                onClick={(e) => setAnchorEl(e.target)}
              >
                <MoreVertIcon height="10px" width="10px" />
              </IconButton>
            )}

            {!message._id && (
              <IconButton size="small">
                <AccessTimeIcon height="10px" width="10px" />
              </IconButton>
            )}
          </div>
        </div>
        <MessageMenu
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          message={message}
          setIsEditingMessage={setIsEditingMessage}
          setNewMessageText={setNewMessageText}
          setTargetEditMessage={setTargetEditMessage}
        />
      </div>
    );
  } else {
    return (
      <div>
        {(isShowProfile) && (
          <div className="sender-message-position mt-4">
            <div className="receiver-message-info">
              <div className="receiver-avatar">
                <UserAvatar
                  image={message?.message_sender?.image}
                  name={`${message?.message_sender?.first_name} ${message?.message_sender?.last_name}`}
                  sx={{ width: "28px", height: "28px", mr: 1 }}
                  alt="sender"
                />
              </div>
              <Typography className="sender-text">
                {capitalize(message?.message_sender?.first_name)}
              </Typography>
            </div>
          </div>
        )}

        <div
          className="d-flex align-items-center message-margin card-positioning justify-content-start"
          style={{
            marginTop:
              !isShowProfile
                ? "1rem"
                : "0.1rem",
          }}
        >
          <div className="d-flex">
            <div
              className="d-flex align-items-end"
              style={{ width: "38px" }}
            ></div>

            <div
              className={`ml-1 message-item received-message reply-effect-container ${repliedMessage?._id === message._id ? "reply-effect" : ""
                }`}
              style={{
                marginTop:
                  !isShowProfile
                    ? "0rem"
                    : "1rem",
              }}
            >
              {isReplyIconVisible && hoveredMessageId === message._id && (
                <div className="reply-btn">
                  <Tooltip
                    arrow
                    title="You can also reply to Message by Double clicking on it."
                  >
                    <IconButton
                      className="textarea-btn mx-2"
                      color="secondary"
                      onClick={() => {
                        setReplyMessage(message);
                        textareaRef.current.focus();
                        console.log(message);
                      }}
                    >
                      <ReplyIcon className="voice-icon-messages" />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {message.message_reactions && message.message_reactions.length > 0 &&
                <ChatMessageReaction emojiList={message.message_reactions} handleRemoveEmoji={handleRemoveEmoji} />
              }
              {selectedMessage && selectedMessage._id == message._id &&
                <div className="chat-reaction-container" ref={emojiPickerRef} >
                  <EmojiPicker
                    onBlur={() => {
                      setSelectedMessage(null);
                    }}
                    reactionsDefaultOpen
                    skinTonePickerLocation="PREVIEW"
                    allowExpandReactions={true}
                    height={300}
                    width={340}
                    onEmojiClick={emojiClickHandle}
                    skinTonesDisabled={true}
                    searchDisabled={true}
                  />
                </div>
              }
              <div className="emojis-btn">
                <Tooltip
                  arrow
                  title="React to this Message"
                >
                  <IconButton
                    className="textarea-btn mx-2"
                    color="secondary"
                    onClick={() => {
                      setSelectedMessage(null);
                      setSelectedMessage(message);
                    }}
                  >
                    <SentimentSatisfiedAltIcon className="voice-icon-messages" />
                  </IconButton>
                </Tooltip>
              </div>
              {message?.reply_message_detail && (
                <TempReply
                  message={message}
                  setRepliedMessage={setRepliedMessage}
                  handleReplyClick={handleReplyClick}
                />
              )}

              {message.image && !message.audio_duration && (
                <>
                  <a href={s3baseUrl + message.image} target="_blank">
                    <img
                      src={s3baseUrl + message.image}
                      loading="lazy"
                      alt="image"
                      className="chat-item-img"
                    />
                  </a>
                  <Typography fontSize={12} className="clickable-link" dangerouslySetInnerHTML={{ __html: linkifyText(message.text) }} />
                </>
              )}

              {message.image && message.audio_duration && (
                <div className="pt-2">
                  <AudioPlayer
                    duration={message.audio_duration}
                    audioUrl={s3baseUrl + message.image}
                  />
                </div>
              )}

              {!message.image && (
                <Typography className="clickable-link" dangerouslySetInnerHTML={{ __html: linkifyText(message.text) }} />
              )}

              <div>
                <Typography className="chat-date">
                  {moment(message.createdAt).format("hh:mm A")}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default memo(MessageItem);
